<app-kpi-widget
  [title]="'fuelChanges.widgets.consumption' | transloco"
  [icon]="icon"
  [isLoading]="isLoading"
  [totalValue]="value"
  [costDifference]="difference"
  [percentageDifference]="fuelConsumptionPercentageChange"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [totalCost]="totalCost"
  [isUptrendPositive]="isUptrendPositive"
  [dropdownOptions]="dropdownOptions"
  [selectedDropdownValue]="selectedUnit"
  [valueFormatter]="formatValue.bind(this)"
  [costFormatter]="formatCost.bind(this)"
  [costDifferenceFormatter]="formatCostDifference.bind(this)"
  (clicked)="openFuelConsumptionModal()"
  (dropdownChanged)="onDropdownChanged($event)">
</app-kpi-widget>